var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBranding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 178,
    viewBox: "0 0 176 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M10.1235 151.341C9.83375 151.341 9.59668 151.103 9.59668 150.812C9.59668 113.136 24.2265 77.7107 50.7993 51.0702C77.3668 24.4297 112.695 9.75439 150.268 9.75439C150.558 9.75439 150.795 9.99211 150.795 10.2827C150.795 10.5732 150.558 10.8109 150.268 10.8109C112.975 10.8109 77.9147 25.3753 51.5421 51.8151C25.1747 78.2601 10.6503 113.416 10.6503 150.812C10.6503 151.103 10.4133 151.341 10.1235 151.341Z",
    fill: "url(#paint0_radial_3090_1280)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3090_1280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147 13.5654V7H153.536V13.5654H147Z",
    stroke: "white",
    strokeWidth: 4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M155.536 5H145V15.5654H155.536V5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.536 5H145V15.5654H155.536V5Z",
    fill: "url(#paint1_linear_3090_1280)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3090_1280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0083 52.5419V49.6035H52.9277V52.5419H50.0083Z",
    stroke: "white",
    strokeWidth: 4
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.9277 47.6035H48.0083V54.5419H54.9277V47.6035Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9277 47.6035H48.0083V54.5419H54.9277V47.6035Z",
    fill: "url(#paint2_linear_3090_1280)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3090_1280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 153.565V147H13.5364V153.565H7Z",
    stroke: "white",
    strokeWidth: 4
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.5364 145H5V155.565H15.5364V145Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5364 145H5V155.565H15.5364V145Z",
    fill: "url(#paint3_linear_3090_1280)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter3_f_3090_1280)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1373 57.0464L62.1364 57.045C62.1341 57.0404 62.1382 57.0351 62.1432 57.0363L124.734 71.4392C128.086 72.2104 130.806 74.6495 131.936 77.8973L146.333 119.261C147.616 122.947 146.637 127.043 143.826 129.75L126.331 146.602C123.441 149.386 119.166 150.172 115.475 148.599L75.7971 131.695C72.781 130.41 70.5863 127.729 69.9232 124.518L57.0059 61.9746L95.0212 99.8589C96.2135 101.047 96.8705 102.699 97.5277 104.352C98.1668 105.959 98.806 107.567 99.9379 108.749C101.817 110.707 104.921 110.775 106.874 108.891C108.826 107.007 108.894 103.894 107.015 101.936C105.885 100.756 104.308 100.052 102.73 99.3485C101.11 98.6253 99.4894 97.9023 98.3565 96.6632L62.1373 57.0464ZM135.926 151.947L150.294 138.106C153.19 135.317 157.791 135.41 160.572 138.312C163.353 141.215 163.261 145.83 160.365 148.618L145.997 162.459C143.102 165.248 138.5 165.156 135.719 162.253C132.938 159.35 133.031 154.736 135.926 151.947Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5653 51.8442L57.5642 51.8426C57.5617 51.8376 57.5662 51.8319 57.5717 51.8332L126.246 67.6358C129.597 68.407 132.317 70.8461 133.448 74.0939L149.484 120.167C150.767 123.853 149.788 127.949 146.977 130.656L127.077 149.824C124.187 152.608 119.912 153.395 116.22 151.822L72.0165 132.99C69.0004 131.705 66.8057 129.023 66.1426 125.812L51.9746 57.2134L93.3918 98.4878C94.6908 99.7823 95.4066 101.582 96.1226 103.383C96.8188 105.134 97.5153 106.885 98.7484 108.173C100.795 110.307 104.177 110.381 106.305 108.328C108.432 106.276 108.506 102.884 106.459 100.751C105.228 99.4654 103.509 98.6984 101.791 97.9317C100.025 97.1438 98.2598 96.3562 97.0256 95.0062L57.5653 51.8442ZM132.581 152.733L149.508 136.427C152.919 133.142 158.34 133.251 161.616 136.67C164.893 140.09 164.783 145.526 161.373 148.812L144.445 165.117C141.035 168.403 135.614 168.294 132.337 164.874C129.061 161.454 129.17 156.019 132.581 152.733Z",
    fill: "url(#paint4_radial_3090_1280)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3090_1280",
    x: 140.537,
    y: 0.536564,
    width: 19.4635,
    height: 19.4923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23172,
    result: "effect1_foregroundBlur_3090_1280"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3090_1280",
    x: 43.5449,
    y: 43.1401,
    width: 15.8463,
    height: 15.8653,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23172,
    result: "effect1_foregroundBlur_3090_1280"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3090_1280",
    x: 0.536564,
    y: 140.537,
    width: 19.4635,
    height: 19.4923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23172,
    result: "effect1_foregroundBlur_3090_1280"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3090_1280",
    x: 44.1059,
    y: 44.1361,
    width: 131.393,
    height: 133.256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.45,
    result: "effect1_foregroundBlur_3090_1280"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3090_1280",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.1958 133.287) rotate(-90) scale(106.48 106.188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3090_1280",
    x1: 150.268,
    y1: 5,
    x2: 150.268,
    y2: 15.5654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3090_1280",
    x1: 51.468,
    y1: 47.6035,
    x2: 51.468,
    y2: 54.5419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3090_1280",
    x1: 10.2682,
    y1: 145,
    x2: 10.2682,
    y2: 155.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3090_1280",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.782 141.335) rotate(-90) scale(77.1497 74.9145)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranding);
export default __webpack_public_path__ + "static/media/Branding.fc758365f2c4ad150d202eff7ebc2ee3.svg";
export { ForwardRef as ReactComponent };